<template>
  <div class="content" v-loading="loading">
    <el-button type="primary" @click="openEditWin('create')">添加</el-button>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="ip" label="广播id"> </el-table-column>
      <el-table-column prop="lamp_id" label="设备识别号"> </el-table-column>
      <el-table-column prop="mic" label="广播麦克风id"> </el-table-column>
      <el-table-column prop="camera" label="萤石云摄像头id"> </el-table-column>
      <!-- <el-table-column prop="hole_id" label="onenet平台井盖设备id"> </el-table-column> -->
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    <!--对话框-->
    <el-dialog
      class="dialog600"
      append-to-body
      v-if="sub_dialogVisible"
      :title="editType === 'create' ? '添加设备' : '修改设备'"
      :visible.sync="sub_dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="160px"
        :rules="editRule"
      >
        <div class="form-info">
          <el-form-item label="NB设备号" prop="lamp_id">
            <el-input v-model="editOne.lamp_id"></el-input>
          </el-form-item>
          <el-form-item label="LoRa设备号" prop="lora_number">
            <el-input v-model="editOne.lora_number"></el-input>
          </el-form-item>
          <el-form-item label="Zigbee设备号" prop="zigbee">
            <el-input v-model="editOne.zigbee"></el-input>
          </el-form-item>
          <el-form-item label="广播id" prop="ip">
            <el-input v-model="editOne.ip"></el-input>
          </el-form-item>
          <el-form-item label="广播麦克风id" prop="mic">
            <el-input v-model="editOne.mic"></el-input>
          </el-form-item>
          <el-form-item label="萤石云摄像头id" prop="camera">
            <el-input v-model="editOne.camera"></el-input>
          </el-form-item>
          <!-- <el-form-item label="onenet平台井盖设备id" prop="hole_id">
            <el-input v-model="editOne.hole_id"></el-input>
          </el-form-item> -->
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="sub_dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import adminsApi from "@/api/auth/admins";
export default {
  name: "deviceList",
  props: {
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      sub_dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10
      },
      cnt_all: 0,
      editType: -1,
      editRule: {
        ip: [{ required: true, message: "请输入广播id", trigger: "blur" }],
        mic: [{ required: true, message: "请输入广播麦克风id", trigger: "blur" }],
        camera: [{ required: true, message: "请输入萤石云摄像头id", trigger: "blur" }]
      },
      editOne: {},
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该设备所选媒体文件列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      adminsApi.userDeviceList(this.userId,this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      console.log('openEditWin_index',index)
      if (index === "create") {
        this.editOne = {
          id: null,
          lamp_id: null,
          lora_number: null,
          zigbee: null,
          ip: null,
          mic: null,
          camera: '',
          admin_id: this.userId

        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          lamp_id: index.lamp_id,
          lora_number: index.lora_number,
          zigbee: index.zigbee,
          ip: index.ip,
          mic: index.mic,
          camera: index.camera,
          admin_id: this.userId
        };
        console.log('this.editOne', this.editOne)
        this.editType = "update";
      }
      this.sub_dialogVisible = true;
    },
    updateItem() {
      adminsApi.userDeviceEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.sub_dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      adminsApi.userDeviceAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.sub_dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          adminsApi.userDeviceDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
